<div id="content-section">
  <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
    <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
        </small>
      </div>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="text-center pagination-small-margin pagination-center">
        <pagination [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="searchParams.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
      <div class="text-center pt-1">
        <app-pagination-count
          [count]="count"
          singularName="Matter"
          pluralName="Matters"
        ></app-pagination-count>
      </div>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="sticky-top bg-white">
        <h5 class="pt-2">
          <div class="pull-right float-right">
            <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
          </div>
          <span>
            Search&nbsp;&nbsp;
            <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search() : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
          </span>
        </h5>
        <hr class="my-1" />
      </div>
      <div class="row">
        <div class="col-md-12" id="search-form" style="border-bottom: 1px solid #ccc">
          <div class="form-group mt-3">
            <label>Matter Name/Number</label>
            <app-matter-search [matterId]="searchParams.matterId" (matter_id)="searchParams.matter_id = $event;setQueryParams();openMatter($event)"></app-matter-search>
          </div>
          <div class="form-group mt-3">
            <label>Rate Type</label>
            <select class="form-control" name="rate_type_id" ngDefaultControl [(ngModel)]="searchParams.rate_type_id">
              <option value=""></option>
              <option *ngFor="let item of searchOptions.rate_types" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="form-group mt-3">
            <label>Matter Status</label>
            <select class="form-control" name="matter_status" ngDefaultControl [(ngModel)]="searchParams.matter_status">
              <option value=""></option>
              <option *ngFor="let item of searchOptions.matter_statuses" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="form-group mt-3">
            <label>Matter Types</label>
            <!-- Pending -->
          </div>
          <div class="form-group mt-3">
            <label>Referral Types</label>
            <select class="form-control" name="referral_type_id" ngDefaultControl [(ngModel)]="searchParams.referral_type_id">
              <option value=""></option>
              <option *ngFor="let item of searchOptions.referral_types" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="form-group mt-3">
            <label>Tagged With (single tag)</label>
            <input type="text" class="form-control" name="tag" ngDefaultControl [(ngModel)]="searchParams.tag" />
          </div>
          <div class="form-group mt-3">
            <label>Matter User</label>
            <!--<div class="custom-control custom-checkbox" (click)='(searchParams.show_inactive == "1" ? ((searchParams.show_inactive = undefined) : (searchParams.show_inactive = "1"))) && (searchParams.matter_user_id = undefined)'>
							<input type="checkbox" class="custom-control-input" name='show_inactive' [checked]='searchParams.show_inactive == "1"' />
							<label class="custom-control-label" >Show Inactive Users</label>
						</div>-->
            <select class="form-control" name="matter_user_id" ngDefaultControl [(ngModel)]="searchParams.matter_user_id">
              <option value=""></option>
              <ng-container *ngIf="searchParams.show_inactive == '1'">
                <option *ngFor="let item of searchOptions.all_matter_users" [value]="item.value">{{ item.label }}</option>
              </ng-container>
              <ng-container *ngIf="searchParams.show_inactive != '1'">
                <option *ngFor="let item of searchOptions.active_matter_users" [value]="item.value">{{ item.label }}</option>
              </ng-container>
            </select>
          </div>
          <div class="form-group mt-3">
            <label>Matter User Type</label>
            <select class="form-control" name="matter_user_type_id" ngDefaultControl [(ngModel)]="searchParams.matter_user_type_id">
              <option value=""></option>
              <option *ngFor="let item of searchOptions.matter_user_types" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="form-group mt-3">
            <label>Default Appointment Location</label>
            <select class="form-control" name="default_appointment_address_id" ngDefaultControl [(ngModel)]="searchParams.default_appointment_address_id">
              <option value=""></option>
              <option *ngFor="let item of searchOptions.default_appointment_addresses" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="form-row">
            <div class="col-6">
              <label>Date From</label>
              <app-datetime-picker [dateStrSeparator]="'/'" [showTimePicker]="false" (ngbResult)="searchParams.date_from_struct = $event"></app-datetime-picker>
            </div>
            <div class="col-6">
              <label>Date To</label>
              <app-datetime-picker [dateStrSeparator]="'/'" [showTimePicker]="false" (ngbResult)="searchParams.date_to_struct = $event"></app-datetime-picker>
            </div>
          </div>
          <div class="form-row">
            <div class="col-6">
              <label>Order By</label>
              <select class="form-control" name="order_by" ngDefaultControl [(ngModel)]="searchParams.order_by">
                <option value=""></option>
                <option *ngFor="let item of searchOptions.order_by" [value]="item.value">{{ item.label }}</option>
              </select>
            </div>
            <div class="col-6">
              <label>In Order Of</label>
              <select class="form-control" name="order_direction" ngDefaultControl [(ngModel)]="searchParams.order_direction">
                <option value=""></option>
                <option *ngFor="let item of searchOptions.order_direction" [value]="item.value">{{ item.label }}</option>
              </select>
            </div>
          </div>
          <div class="form-group mt-3">
            <label>Flexible Search</label>
            <input type="text" class="form-control" name="flex_search" ngDefaultControl (keyup.enter)="search()" [(ngModel)]="searchParams.text" />
          </div>
          <div class="form-group">
            <label>Tagged With (single tag)</label>
            <input type="text" class="form-control" name="tag" ngDefaultControl [(ngModel)]="searchParams.tag" (keyup.enter)="search()" />
          </div>
          <div class="form-group">
            <label>Zip or Postal Code</label>
            <input type="text" class="form-control" name="postal_code" ngDefaultControl [(ngModel)]="searchParams.postal_code" (keyup.enter)="search()" />
          </div>
          <div class="form-group">
            <label>County</label>
            <input type="text" class="form-control" name="county" ngDefaultControl [(ngModel)]="searchParams.county" (keyup.enter)="search()" />
          </div>
          <div class="form-group">
            <label>City</label>
            <input type="text" class="form-control" name="city" ngDefaultControl [(ngModel)]="searchParams.city" (keyup.enter)="search()" />
          </div>
          <!-- Not in use for current solr search
					<div class='form-group'>
						<label>Matter User</label>
						<select class='form-control' name='user_id' [(ngModel)]='searchParams.user_id'>
							<option *ngFor='let matterUser of this.searchOptions.matter_users' [value]='matterUser.value'>
								{{matterUser.label}}
							</option>
						</select>
					</div>
					-->
          <div class="form-group">
            <label>Matter</label>
            <app-matter-search (clearMatter)="searchParams.matter_id = undefined" (matter_id)="searchParams.matter_id = $event"></app-matter-search>
            <small class="form-text text-muted">Limit to involvements of this matter</small>
          </div>
          <hr />
          <div class="form-group">
            <label>Filter by one of the below</label><br />
            <div class="custom-control custom-radio custom-control-inline" (click)="searchOptions.radio_1 = 'role_types'">
              <input type="radio" name="radio_1" [checked]="searchOptions.radio_1 == 'role_types' || !searchOptions.radio_1" class="custom-control-input" />
              <label class="custom-control-label">Role Types</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline" (click)="searchOptions.radio_1 = 'matter_user_types'; searchParams.role_type_ids = []; searchParams.role_types = []">
              <input type="radio" name='radio_1' [checked]="searchOptions.radio_1 == 'matter_user_types'" name="radio_1" class="custom-control-input" />
              <label class="custom-control-label">Matter User Types</label>
            </div>
          </div>
          <div class="form-group" *ngIf="searchOptions.radio_1 == 'role_types' || !searchOptions.radio_1">
            <label>Involvement Role</label>
            <input type="text" class="form-control" [(ngModel)]="selectedRoleType" [typeahead]="searchOptions.role_types" (typeaheadOnSelect)="addRoleTypeToSearch($event.item)" typeaheadOptionField="name" name="role_search" ngDefaultControl placeholder="Search and Add" *ngIf="searchOptions.role_types.length > 0" />
            <div class="card mt-1">
              <div class="card-body p-2" style="height: 70px; overflow-y: scroll">
                <div *ngFor="let roleType of this.searchParams.role_types; first as isFirst" [ngClass]="{ 'border-top': !isFirst }">
                  <div class="float-right py-1">
                    <a class="text-danger" href="#" (click)="$event.stopPropagation(); $event.preventDefault(); removeRoleTypeFromSearch(roleType)">
                      <i class="fas fa-times"></i>
                    </a>
                  </div>
                  {{ roleType.label }}
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="searchOptions.radio_1 == 'matter_user_types'">
            <label>Matter User Type</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="selectedMatterUserType"
              [typeahead]="searchOptions.matter_user_types"
              (typeaheadOnSelect)="addMatterUserTypeToSearch($event.item)"
              typeaheadOptionField="name"
              name="matter_user_type_search"
              ngDefaultControl
              placeholder="Search and Add"
              *ngIf="searchOptions.matter_user_types.length > 0"
            />
            <div class="card mt-1">
              <div class="card-body p-2" style="height: 70px; overflow-y: scroll">
                <div *ngFor="let matterUserType of this.searchParams.matter_user_types; first as isFirst" [ngClass]="{ 'border-top': !isFirst }">
                  <div class="float-right py-1">
                    <a class="text-danger" href="#" (click)="$event.stopPropagation(); $event.preventDefault(); removeMatterUserTypeFromSearch(matterUserType)">
                      <i class="fas fa-times"></i>
                    </a>
                  </div>
                  {{ matterUserType.label }}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <!-- Not being used in solr at the moment
					<div class='form-group'>
						<label>Matter Type</label>
						<input type='text' class='form-control' [(ngModel)]='selectedMatterType' [typeahead]="searchOptions.matter_types" (typeaheadOnSelect)='addMatterTypeToSearch($event.item)' typeaheadOptionField="name" name='matter_type_search' placeholder='Search and Add' *ngIf='searchOptions.matter_types.length > 0' />
						<div class='card mt-1'>
							<div class='card-body p-2' style='height: 70px;overflow-y: scroll;'>
								<div *ngFor='let matterType of this.searchParams.matter_types; first as isFirst' [ngClass]='{ "border-top": !isFirst }'>
									<div class='float-right py-1'>
										<a class='text-danger' href='#' (click)='$event.stopPropagation();$event.preventDefault();removeMatterTypeFromSearch(matterType)'>
											<i class='fa fa-times'></i>
										</a>
									</div>
									{{matterType.label}}
								</div>
							</div>
						</div>
					</div>
					-->
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="searchParams.is_on_mailing_list = !searchParams.is_on_mailing_list; searchParams.is_on_mailing_list ? searchParams.is_on_mailing_list : (searchParams.is_on_mailing_list = undefined)">
              <input type="checkbox" class="custom-control-input" name="is_on_mailing_list" ngDefaultControl [checked]="searchParams.is_on_mailing_list" />
              <label class="custom-control-label">On Mailing List</label>
            </div>
          </div>
          <div class="form-group">
            <button (click)="searchParams.page = 1; search()" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
              Search
              <span *ngIf="searching">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <h2 class="pt-4 text-center">Matters</h2>
        <hr class="mt-1 mb-2" />
        <div class="card mb-2" *ngIf="count > 0">
          <div class="card-header">
            <a href="#" (click)="showBulkEdit = !showBulkEdit; $event.preventDefault(); $event.stopPropagation()"> <i class="fas" [ngClass]="{ 'fa-plus-circle': !showBulkEdit, 'fa-minus-circle': showBulkEdit }"></i>Bulk Edit </a>
          </div>
          <div class="card-body" *ngIf="showBulkEdit">
            <p class="card-text text-muted">Select matters for edit below the form</p>
            <p class="card-text text-muted">Leave a value blank to not change that value, select matters for edit below the form</p>
            <div class="form-group">
              <div class="custom-control custom-checkbox" (click)="bulkEditParams.email_changes = !bulkEditParams.email_changes">
                <input type="checkbox" class="custom-control-input" name="email_changes" [checked]="bulkEditParams.email_changes" />
                <label class="custom-control-label">Email Notification Of Changes (may be overwritten)</label>
              </div>
            </div>
            <div class="form-group">
              <label>Memo For History</label>
              <textarea class="form-control" name="history_memo" ngDefaultControl placeholder="History Memo" [(ngModel)]="bulkEditParams.history_memo"></textarea>
            </div>
            <div class="form-group">
              <h4 class="card-title">REMOVE</h4>
              <p class="card-text">
                If you want to remove a matter user, select the user, or the type, or both when you want to limit the role the user played in the matter.
                <br />
                Do&nbsp;
                <b>NOT</b>&nbsp; use this to replace a lead attorney.
                <br />
                Use 'add' below instead!
              </p>
              <label>Remove Matter User Type</label>
              <select class="form-control" name="remove_matter_user_type_id" ngDefaultControl [(ngModel)]="bulkEditParams.remove_matter_user_type_id">
                <option>-</option>
                <option *ngFor="let matterUserType of bulkEditOptions.matter_user_types" [value]="matterUserType.value">{{ matterUserType.label }}</option>
              </select>
              <label>Remove Matter User</label>
              <select class="form-control" name='remove_matter_user_id' ngDefaultControl [(ngModel)]="bulkEditParams.remove_matter_user_id">
                <option>-</option>
                <option *ngFor="let matterUser of bulkEditOptions.matter_users" [value]="matterUser.value">{{ matterUser.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <h4 class="card-title">ADD</h4>
              <p class="card-text">
                If you want to add a matter user, select the user and the role you want that user to play.
                <br />
                If you indicate that the role is lead attorney, the existing lead attorney will be replaced and demoted to attorney if active, and inactive if the user is not active.
              </p>
              <label>Add Matter User Type</label>
              <select class="form-control" name="add_matter_user_type_id" ngDefaultControl [(ngModel)]="bulkEditParams.add_matter_user_type_id">
                <option>-</option>
                <option *ngFor="let matterUserType of bulkEditOptions.matter_user_types" [value]="matterUserType.value">{{ matterUserType.label }}</option>
              </select>
              <label>Add Matter User</label>
              <select class="form-control" name='add_matter_user_id' ngDefaultControl [(ngModel)]="bulkEditParams.add_matter_user_id">
                <option>-</option>
                <option *ngFor="let matterUser of bulkEditOptions.matter_users" [value]="matterUser.value">{{ matterUser.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <h4 class="card-title">CHANGE</h4>
              <p class="card-text">
                If you want to change a matter user's role, select the user and the new role.
                <br />
                Do not use to change or replace a Lead Attorney.
                <br />
                If used to change an attorney, the attorney will be changed to an Inactive Attorney and notification will be turned off.
              </p>
              <label>Change To User Type</label>
              <select class="form-control" name="change_matter_user_type_id" ngDefaultControl [(ngModel)]="bulkEditParams.change_matter_user_type_id">
                <option>-</option>
                <option *ngFor="let matterUserType of bulkEditOptions.matter_user_types" [value]="matterUserType.value">{{ matterUserType.label }}</option>
              </select>
              <label>Matter User To Change</label>
              <select class="form-control" name='new_matter_user_id' ngDefaultControl [(ngModel)]="bulkEditParams.new_matter_user_id">
                <option>-</option>
                <option *ngFor="let matterUser of bulkEditOptions.matter_users" [value]="matterUser.value">{{ matterUser.label }}</option>
              </select>
              <div class="custom-control custom-checkbox" (click)="bulkEditParams.remove_opener = !bulkEditParams.remove_opener">
                <input type="checkbox" class="custom-control-input" name="remove_opener" ngDefaultControl [checked]="bulkEditParams.remove_opener" />
                <label class="custom-control-label">Remove Opener If Changed User</label>
              </div>
            </div>
            <div class="form-group">
              <h4 class="card-title">REPLACE</h4>
              <p class="card-text">
                If you want to remove a matter user and add a replacement, select the new user and the role you want them to play/replace in all the selected matters.
                <br />
                Do&nbsp;
                <b>NOT</b>&nbsp; use this to replace a lead attorney.
                <br />
                Use 'add' to replace a lead attorney.
              </p>
              <label>Change To User Type</label>
              <select class="form-control" name="change_matter_user_type_id" ngDefaultControl [(ngModel)]="bulkEditParams.change_matter_user_type_id">
                <option>-</option>
                <option *ngFor="let matterUserType of bulkEditOptions.matter_user_types" [value]="matterUserType.value">{{ matterUserType.label }}</option>
              </select>
              <label>Matter User To Change</label>
              <select class="form-control" name='new_matter_user_id' ngDefaultControl [(ngModel)]="bulkEditParams.new_matter_user_id">
                <option>-</option>
                <option *ngFor="let matterUser of bulkEditOptions.matter_users" [value]="matterUser.value">{{ matterUser.label }}</option>
              </select>
              <label>Matter User To Be Replaced</label>
              <select class="form-control" name='old_matter_user_id' ngDefaultControl [(ngModel)]="bulkEditParams.old_matter_user_id">
                <option>-</option>
                <option *ngFor="let matterUser of bulkEditOptions.matter_users" [value]="matterUser.value">{{ matterUser.label }}</option>
              </select>
              <div class="custom-control custom-checkbox" (click)="bulkEditParams.remove_opener = !bulkEditParams.remove_opener">
                <input type="checkbox" class="custom-control-input" name="remove_opener" [checked]="bulkEditParams.remove_opener" />
                <label class="custom-control-label">Remove Opener If Removed User</label>
              </div>
            </div>
            <div class="form-group">
              <label>Include in all communications</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.include_in_all = ''">
                <input type="radio" name="include_in_all" class="custom-control-input" value="" [checked]="bulkEditParams.include_in_all == ''" />
                <label class="custom-control-label">Don't Change</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.include_in_all = '1'">
                <input type="radio" name="include_in_all" class="custom-control-input" value="1" [checked]="bulkEditParams.include_in_all == '1'" />
                <label class="custom-control-label">Yes</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.include_in_all = '0'">
                <input type="radio" name="include_in_all" class="custom-control-input" value="0" [checked]="bulkEditParams.include_in_all == '0'" />
                <label class="custom-control-label">No</label>
              </div>
            </div>
            <div class="form-group">
              <label>Add Detail Type</label>
              <select class="form-control" [(ngModel)]="bulkEditParams.detail_type_id" name="detail_type_id" ngDefaultControl>
                <option>-</option>
                <option *ngFor="let detailType of bulkEditOptions.detail_types" [value]="detailType.value">{{ detailType.label }}</option>
              </select>
              <label>Add Detail Value</label>
              <textarea class="form-control" name="detail_value" ngDefaultControl [(ngModel)]="bulkEditParams.detail_value"></textarea>
            </div>
            <div class="form-group">
              <label>Default Appointment Address</label>
              <select class="form-control" [(ngModel)]="bulkEditParams.default_appointment_address_id_bulk_edit" ngDefaultControl name="default_appointment_address_id_bulk_edit">
                <option>-</option>
                <option *ngFor="let address of bulkEditOptions.default_appointment_addresses" [value]="address.value">{{ address.label }}</option>
              </select>
              <div class="custom-control custom-checkbox" (click)="bulkEditParams.only_blank_default_appointment_address_id = !bulkEditParams.only_blank_default_appointment_address_id">
                <input type="checkbox" class="custom-control-input" name="only_blank_default_appointment_address_id" [checked]="bulkEditParams.only_blank_default_appointment_address_id" />
                <label class="custom-control-label">Only If Blank</label>
              </div>
            </div>
            <div class="form-group">
              <label>Jurisdiction</label>
              <textarea class="form-control" name="jurisdiction" ngDefaultControl [(ngModel)]="bulkEditParams.jurisdiction"></textarea>
              <div class="custom-control custom-checkbox" (click)="bulkEditParams.only_blank_jurisdiction = !bulkEditParams.only_blank_jurisdiction">
                <input type="checkbox" class="custom-control-input" name="only_blank_jurisdiction" [checked]="bulkEditParams.only_blank_jurisdiction" />
                <label class="custom-control-label">Only If Blank</label>
              </div>
            </div>
            <div class="form-group">
              <label>Do Invoice</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.do_invoice_bulk_edit = ''">
                <input type="radio" name="do_invoice_bulk_edit" class="custom-control-input" value="" [checked]="bulkEditParams.do_invoice_bulk_edit == ''" />
                <label class="custom-control-label">Don't Change</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.do_invoice_bulk_edit = '1'">
                <input type="radio" name="do_invoice_bulk_edit" class="custom-control-input" value="1" [checked]="bulkEditParams.do_invoice_bulk_edit == '1'" />
                <label class="custom-control-label">Yes</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.do_invoice_bulk_edit = '0'">
                <input type="radio" name="do_invoice_bulk_edit" class="custom-control-input" value="0" [checked]="bulkEditParams.do_invoice_bulk_edit == '0'" />
                <label class="custom-control-label">No</label>
              </div>
            </div>
            <div class="form-group">
              <label>Auto-Pay from Escrow</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.auto_pay_from_escrow_bulk_edit = ''">
                <input type="radio" name="auto_pay_from_escrow_bulk_edit" class="custom-control-input" value="" [checked]="bulkEditParams.auto_pay_from_escrow_bulk_edit == ''" />
                <label class="custom-control-label">Don't Change</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.auto_pay_from_escrow_bulk_edit = '1'">
                <input type="radio" name="auto_pay_from_escrow_bulk_edit" class="custom-control-input" value="1" [checked]="bulkEditParams.auto_pay_from_escrow_bulk_edit == '1'" />
                <label class="custom-control-label">Yes</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.auto_pay_from_escrow_bulk_edit = '0'">
                <input type="radio" name="auto_pay_from_escrow_bulk_edit" class="custom-control-input" value="0" [checked]="bulkEditParams.auto_pay_from_escrow_bulk_edit == '0'" />
                <label class="custom-control-label">No</label>
              </div>
            </div>
            <div class="form-group">
              <label>Notes</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_notes = '1'">
                <input type="radio" name="append_notes" class="custom-control-input" value="1" [checked]="bulkEditParams.append_notes == '1'" />
                <label class="custom-control-label">Append</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_notes = '0'">
                <input type="radio" name="append_notes" class="custom-control-input" value="0" [checked]="bulkEditParams.append_notes == '0'" />
                <label class="custom-control-label">Replace</label>
              </div>
              <textarea class="form-control" name="notes" ngDefaultControl [(ngModel)]="bulkEditParams.notes"></textarea>
            </div>
            <div class="form-group">
              <label>Tags&nbsp;&nbsp;&nbsp;&nbsp;</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_tags = '1'">
                <input type="radio" name="append_tags" class="custom-control-input" value="1" [checked]="bulkEditParams.append_tags == '1'" />
                <label class="custom-control-label">Append</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_tags = '0'">
                <input type="radio" name="append_tags" class="custom-control-input" value="0" [checked]="bulkEditParams.append_tags == '0'" />
                <label class="custom-control-label">Replace</label>
              </div>
              <input class="form-control" name="tag_list" ngDefaultControl placeholder="Tags" [(ngModel)]="bulkEditParams.tag_list" />
            </div>
            <div class="form-group">
              <label>Status</label>
              <select class="form-control" [(ngModel)]="bulkEditParams.matter_status_bulk_edit" ngDefaultControl name="matter_status_bulk_edit">
                <option>-</option>
                <option *ngFor="let matterStatus of bulkEditOptions.matter_statuses" [value]="matterStatus.value">{{ matterStatus.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <button [disabled]="submittingBulkEdit" type="button" class="btn btn-primary" (click)="bulkEdit()">
                Save
                <span *ngIf="submittingBulkEdit">
                  &nbsp;
                  <i class="fas fa-spinner fa-fw fa-pulse"></i>
                </span>
              </button>
              &nbsp;
              <button [disabled]="submittingBulkEdit" type="button" class="btn btn-primary" (click)="bulkEdit()">
                Prepare Matter Summary
                <span *ngIf="submittingBulkEdit">
                  &nbsp;
                  <i class="fas fa-spinner fa-fw fa-pulse"></i>
                </span>
              </button>
              &nbsp;
              <button [disabled]="submittingBulkEdit" type="button" class="btn btn-outline-secondary" (click)="showBulkEdit = false">Cancel</button>
            </div>
          </div>
        </div>
        <div class="table-responsive-md">
          <table class="table table-striped" *ngIf="count > 0">
            <thead>
              <tr *ngIf="showBulkEdit">
                <td>
                  <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.contacts_bulk_edit_selection = 'select_all'">
                    <input type="radio" name="contacts_bulk_edit_selection" class="custom-control-input" [checked]="bulkEditParams.contacts_bulk_edit_selection == 'select_all'" />
                    <label class="custom-control-label">Select All results</label>
                  </div>
                </td>
                <td>
                  <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.contacts_bulk_edit_selection = 'select_current'">
                    <input type="radio" name="contacts_bulk_edit_selection" class="custom-control-input" [checked]="bulkEditParams.contacts_bulk_edit_selection == 'select_current'" />
                    <label class="custom-control-label">Select All in current page</label>
                  </div>
                </td>
                <td>
                  <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.contacts_bulk_edit_selection = 'user_select'">
                    <input type="radio" name="contacts_bulk_edit_selection" class="custom-control-input" [checked]="bulkEditParams.contacts_bulk_edit_selection == 'user_select'" />
                    <label class="custom-control-label">My Selection (available for matters in current page only)</label>
                  </div>
                </td>
                <td>
                  <button type="button" (click)="deselectAll()" class="btn btn-outline-secondary btn-sm"><i class="fas fa-ban"></i>&nbsp;Deselect all</button>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let matter of matters">
                <td>
                  <div *ngIf="bulkEditParams.matters_bulk_edit_selection == 'user_select' && showBulkEdit">
                    <div class="custom-control custom-checkbox custom-control-inline" (click)="matter.selected = !matter.selected">
                      <input type="checkbox" class="custom-control-input" name='matter_selected' [checked]="matter.selected" />
                      <label class="custom-control-label"></label>
                    </div>
                  </div>
                </td>
                <td>
                  <a [routerLink]="'/matters/' + matter.id">
                    {{ matter.case_name }}
                  </a>
                </td>
                <td></td>
                <td></td>
                <td>
                  <span *ngIf="matter.matter_ids_size < 1"> No Matters </span>
                  <span *ngIf="matter.matter_ids_size > 0">
                    <a [href]="matter.matters_url" [title]="'Go to the ' + matter.matter_ids_size + ' matters for ' + matter.case_name" target="_blank">
                      <i class="fas fa-link"></i>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
